import { H5 } from "@sellar-io/components";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Expandable } from "./Expandable";

export const ExpandableSection = ({
  children,
  title,
  expanded,
  onClick,
  className,
}: {
  children: ReactNode;
  title: ReactNode;
  expanded: boolean;
  onClick?: () => void;
  className?: string;
}) => {
  return (
    <Expandable expanded={expanded} onClick={onClick} className={className}>
      <div className={"flex flex-col gap-2"}>
        <H5>{title}</H5>
        <div className={twMerge(!expanded && "hidden")}>{children}</div>
      </div>
    </Expandable>
  );
};
